import vehicleUserMapService from "@/api/vehicleUserMapService";
// import { randomBytes } from "crypto";

const state = {};

const getters = {
   getLoaderStatus: (state, getters, rootState, rootGetters) => rootGetters.getLoaderStatus,
   getUsers: (state, getters, rootState, rootGetters) => rootGetters.getUsers,
   getUserRoles: (state, getters, rootState, rootGetters) => rootGetters.getUserRoles,
   getVehicleUserMap: (state, getters, rootState, rootGetters) => rootGetters.getVehicleUserMap,
};

const actions = {
    async loadVehicleUserMap({ commit }) {
        const response = await vehicleUserMapService.getVehicleUserMap();
        // TODO delete this mock once id issue fixed
        console.log(response.data)
        commit('setVehicleUserMap', response.data, { root: true });
    },
    async updateVehicleUserMap ({ commit }, body) {
        console.log('#add 1 Updating record : ', body);
        body.vehicleInfo.users =  body.users;
        console.log('#add 2 Updating record : ', body);
        const { data } = await vehicleUserMapService.updateVehicleUserMap(body.vehicleInfo.vehicleId, [body.vehicleInfo]);
        console.log("#add 3 result ", data);
        commit('updateVehicleUserMap', data.result, { root: true });
    },
};    

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};